import { render } from "./option-group.vue?vue&type=template&id=61521104"
import script from "./option-group.vue?vue&type=script&lang=js"
export * from "./option-group.vue?vue&type=script&lang=js"

import "./option-group.vue?vue&type=style&index=0&id=61521104&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/global/select/option-group.vue'],['render',render],['__file',"option-group.vue"]])

export default __exports__